import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToShip = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 21C2.2 21.3 2.5 21.6 2.9 21.7C3.2 21.9 3.6 22 4 22C4.4 22 4.8 21.9 5.1 21.7C5.5 21.6 5.8 21.3 6 21C6.2 20.7 6.5 20.4 6.9 20.3C7.2 20.1 7.6 20 8 20C8.4 20 8.8 20.1 9.1 20.3C9.4 20.5 9.7 20.7 10 21C10.2 21.3 10.5 21.6 10.9 21.7C11.2 21.9 11.6 22 12 22C12.4 22 12.8 21.9 13.1 21.7C13.4 21.5 13.7 21.3 14 21C14.3 20.7 14.5 20.4 14.9 20.3C15.2 20.1 15.6 20 16 20C16.4 20 16.8 20.1 17.1 20.3C17.4 20.5 17.7 20.7 18 21C18.3 21.3 18.5 21.6 18.9 21.7C19.2 21.9 19.6 22 20 22C20.4 22 20.8 21.9 21.1 21.7C21.4 21.5 21.7 21.3 22 21",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.90002 17.4H20.7H8.90002H3.90002Z",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4 13.4H17.3H22.6L20.6 17.4",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 7H13L17 13",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3 7V3H9.30005",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.30005 12.4H10.3",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.30005 10.2L10.3 12.4L7.30005 14.6",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgToShip;
